// Automatically import all rank insignia images used in the application.
// The images live under `src/assets/insignias` and are named
// `arvomerkki-<number>.png` from 1 to 55.

export const insignias: string[] = Array.from(
  { length: 55 },
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require, @typescript-eslint/no-unsafe-assignment
  (_, i) => require(`../assets/insignias/arvomerkki-${i + 1}.png`) as string
)
